import { request } from "../base";

export type WhatsAppRecipient = {
	id: number;
	proId: string;
	label: string;
	number: string;
	isPrimary: boolean;
	notificationsEnabled: boolean;
	isVerified: boolean;
	verifiedAt: string | null;
	otpPendingUntil: string | null;
	otpLastSentAt: string | null;
	dateCreated: string;
	dateUpdated: string;
};

export type WhatsAppRecipientListResponse = {
	recipients: WhatsAppRecipient[];
	maxAllowed: number;
};

export type CreateWhatsAppRecipientInput = {
	label: string;
	number: string;
	isPrimary?: boolean;
};

export type UpdateWhatsAppRecipientInput = {
	label?: string;
	notificationsEnabled?: boolean;
	isPrimary?: true;
};

export const whatsappRecipientsApi = {
	async list(proId: string): Promise<WhatsAppRecipientListResponse> {
		const res = await request<WhatsAppRecipientListResponse>(
			`/api/pro/${proId}/whatsapp-recipients`,
		);
		if (!res.data) throw new Error("Empty response");
		return res.data;
	},

	async create(
		proId: string,
		input: CreateWhatsAppRecipientInput,
	): Promise<WhatsAppRecipient> {
		const res = await request<{ recipient: WhatsAppRecipient }>(
			`/api/pro/${proId}/whatsapp-recipients`,
			{ method: "POST", body: input },
		);
		if (!res.data) throw new Error("Empty response");
		return res.data.recipient;
	},

	async update(
		proId: string,
		id: number,
		patch: UpdateWhatsAppRecipientInput,
	): Promise<WhatsAppRecipient> {
		const res = await request<{ recipient: WhatsAppRecipient }>(
			`/api/pro/${proId}/whatsapp-recipients/${id}`,
			{ method: "PATCH", body: patch },
		);
		if (!res.data) throw new Error("Empty response");
		return res.data.recipient;
	},

	async remove(proId: string, id: number): Promise<void> {
		await request(`/api/pro/${proId}/whatsapp-recipients/${id}`, {
			method: "DELETE",
		});
	},

	async verify(
		proId: string,
		id: number,
		code: string,
	): Promise<WhatsAppRecipient> {
		const res = await request<{ recipient: WhatsAppRecipient }>(
			`/api/pro/${proId}/whatsapp-recipients/${id}/verify`,
			{ method: "POST", body: { code } },
		);
		if (!res.data) throw new Error("Empty response");
		return res.data.recipient;
	},

	async resendOtp(
		proId: string,
		id: number,
	): Promise<{ recipient: WhatsAppRecipient; cooldownSeconds: number }> {
		const res = await request<{
			recipient: WhatsAppRecipient;
			cooldownSeconds: number;
		}>(`/api/pro/${proId}/whatsapp-recipients/${id}/resend-otp`, {
			method: "POST",
		});
		if (!res.data) throw new Error("Empty response");
		return res.data;
	},
};
